import { Label } from "./ui/label";
import { Input } from "./ui/input";

const GST_PRESETS = {
  cgst_sgst: { cgst_rate: 9, sgst_rate: 9, igst_rate: 0 },
  igst: { cgst_rate: 0, sgst_rate: 0, igst_rate: 18 },
  none: { cgst_rate: 0, sgst_rate: 0, igst_rate: 0 },
};

export default function GSTInput({ cgst_rate, sgst_rate, igst_rate, onChange, handleNumericInput }) {
  const currentType =
    parseFloat(igst_rate) > 0 ? "igst" :
    (parseFloat(cgst_rate) > 0 || parseFloat(sgst_rate) > 0) ? "cgst_sgst" : "none";

  const handleTypeChange = (type) => {
    const preset = GST_PRESETS[type];
    onChange(preset);
  };

  return (
    <div className="space-y-2">
      <Label className="text-xs font-medium text-slate-600">GST Type</Label>
      <div className="flex gap-1.5">
        {[
          { key: "cgst_sgst", label: "CGST + SGST" },
          { key: "igst", label: "IGST" },
          { key: "none", label: "No GST" },
        ].map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => handleTypeChange(opt.key)}
            data-testid={`gst-type-${opt.key}`}
            className={`flex-1 px-3 py-1.5 text-xs font-semibold rounded-md border transition-all ${
              currentType === opt.key
                ? "bg-brand-navy text-white border-brand-navy shadow-sm"
                : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {currentType !== "none" && (
        <div className="grid grid-cols-3 gap-3 pt-1">
          <div>
            <Label className="text-xs text-slate-500">CGST %</Label>
            <Input
              type="text" inputMode="decimal"
              value={cgst_rate}
              onChange={(e) => onChange({ cgst_rate: handleNumericInput(e.target.value) })}
              placeholder="0"
              disabled={currentType === "igst"}
              className={currentType === "igst" ? "bg-slate-50 text-slate-400" : ""}
              data-testid="input-cgst"
            />
          </div>
          <div>
            <Label className="text-xs text-slate-500">SGST %</Label>
            <Input
              type="text" inputMode="decimal"
              value={sgst_rate}
              onChange={(e) => onChange({ sgst_rate: handleNumericInput(e.target.value) })}
              placeholder="0"
              disabled={currentType === "igst"}
              className={currentType === "igst" ? "bg-slate-50 text-slate-400" : ""}
              data-testid="input-sgst"
            />
          </div>
          <div>
            <Label className="text-xs text-slate-500">IGST %</Label>
            <Input
              type="text" inputMode="decimal"
              value={igst_rate}
              onChange={(e) => onChange({ igst_rate: handleNumericInput(e.target.value) })}
              placeholder="0"
              disabled={currentType === "cgst_sgst"}
              className={currentType === "cgst_sgst" ? "bg-slate-50 text-slate-400" : ""}
              data-testid="input-igst"
            />
          </div>
        </div>
      )}
    </div>
  );
}
